<template>
  <template v-if="isLoading">
    <RevTable
      :collection
      :columns="formattedColumns"
      striped-rows
      transparent-header
    >
      <template #body-a="{ item }">
        <RevSkeleton
          :class="CLASS_ROW"
          :height="HEIGHT"
          shape="line"
          :width="item.a"
        />
      </template>
      <template #body-b="{ item }">
        <RevSkeleton
          :class="CLASS_ROW"
          :height="HEIGHT"
          shape="line"
          :width="item.b"
        />
      </template>
      <template #body-c="{ item }">
        <RevSkeleton
          :class="CLASS_ROW"
          :height="HEIGHT"
          shape="line"
          :width="item.c"
        />
      </template>
      <template #body-d="{ item }">
        <RevSkeleton
          :class="CLASS_ROW"
          :height="HEIGHT"
          shape="line"
          :width="item.d"
        />
      </template>
      <template #body-e="{ item }">
        <RevSkeleton
          :class="CLASS_ROW"
          :height="HEIGHT"
          shape="line"
          :width="item.e"
        />
      </template>
      <template #body-f="{ item }">
        <RevSkeleton
          :class="CLASS_ROW"
          :height="HEIGHT"
          shape="line"
          :width="item.f"
        />
      </template>
      <template #body-g="{ item }">
        <RevSkeleton
          :class="CLASS_ROW"
          :height="HEIGHT"
          shape="line"
          :width="item.g"
        />
      </template>
      <template #body-h="{ item }">
        <RevSkeleton
          :class="CLASS_ROW"
          :height="HEIGHT"
          shape="line"
          :width="item.h"
        />
      </template>
      <template #body-i="{ item }">
        <RevSkeleton
          :class="CLASS_ROW"
          :height="HEIGHT"
          shape="line"
          :width="item.i"
        />
      </template>
      <template #body-j="{ item }">
        <RevSkeleton
          :class="CLASS_ROW"
          :height="HEIGHT"
          shape="line"
          :width="item.j"
        />
      </template>
      <template #body-k="{ item }">
        <RevSkeleton
          :class="CLASS_ROW"
          :height="HEIGHT"
          shape="line"
          :width="item.k"
        />
      </template>
      <template #body-l="{ item }">
        <RevSkeleton
          :class="CLASS_ROW"
          :height="HEIGHT"
          shape="line"
          :width="item.l"
        />
      </template>
      <template #body-m="{ item }">
        <RevSkeleton
          :class="CLASS_ROW"
          :height="HEIGHT"
          shape="line"
          :width="item.m"
        />
      </template>
      <template #body-n="{ item }">
        <RevSkeleton
          :class="CLASS_ROW"
          :height="HEIGHT"
          shape="line"
          :width="item.n"
        />
      </template>
    </RevTable>
  </template>
  <template v-if="!isLoading">
    <slot />
  </template>
</template>

<script setup lang="ts">
import { computed } from 'vue'

import { tw } from '@backmarket/utils/string/tw'
import { RevSkeleton } from '@ds/components/Skeleton'
import { RevTable } from '@ds/components/Table'
import type { Column } from '@ds/components/Table/Table.constant'

const KEYS = [
  'a',
  'b',
  'c',
  'd',
  'e',
  'f',
  'g',
  'h',
  'i',
  'j',
  'k',
  'l',
  'm',
  'n',
  'o',
  'p',
  'q',
  'r',
  's',
  't',
  'u',
  'v',
  'w',
  'x',
  'y',
  'z',
] as const
const HEIGHT = '12px'
const CLASS_ROW = tw`my-6 bg-surface-default-hi`

const props = defineProps<{
  isLoading: boolean
  columns: Column[]
}>()

function random(min: number, max: number) {
  return Math.floor(Math.random() * (max - min + 1) + min)
}

const formattedColumns = computed(() =>
  (props.columns || []).map((column, i) => ({
    ...column,
    key: KEYS[i],
  })),
)

const collection = computed(() => {
  // Build 3 items
  return Array(3)
    .fill(null)
    .map(() =>
      formattedColumns.value.reduce(
        (acc, column) => ({
          ...acc,
          [column.key]: `${random(50, 100)}px`,
        }),
        {} as Record<(typeof KEYS)[number], string>,
      ),
    )
})
</script>
